import CryptoJS from 'crypto-js';

class CryptoWrapper {
    encrypt(text, secretKey, iv) {
        const _key = CryptoJS.enc.Utf8.parse(secretKey);
        const _iv = CryptoJS.enc.Utf8.parse(iv);
        const cipher = CryptoJS.AES.encrypt(`${text}`, _key, {
            iv: _iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        });

        return CryptoJS.enc.Hex.stringify(cipher.ciphertext)
    }

    decrypt(hex, secretKey, iv) {
        const _key = CryptoJS.enc.Utf8.parse(secretKey);
        const _iv = CryptoJS.enc.Utf8.parse(iv);
        const cipherParams = CryptoJS.lib.CipherParams.create({
            ciphertext: CryptoJS.enc.Hex.parse(hex)
        });
        const decrypt = CryptoJS.AES.decrypt(cipherParams, _key, {
            iv: _iv,
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        });

        return decrypt.toString(CryptoJS.enc.Utf8);
    }
}

export default new CryptoWrapper()